// @flow
import type {Node} from 'react'
import React from 'react'
import classNames from 'classnames'

import FormGroup from 'components/ui/FormGroup'
import styles from './index.scss'

type Props = $ReadOnly<{
  id: string,
  rightButton: ?Node,
  value: string,
  strikethrough: boolean,
}>

function DisabledRoleName({id, rightButton, value, strikethrough}: Props): Node {
  const legacyClasses = classNames(
    'form-control',
    'refinery-input',
    'refinery-value-pill',
    'refinery-value-pill--unchanged',
    'test-refinery-value-pill',
    {'refinery-input--strikethrough': strikethrough},
  )

  return (
    <FormGroup
      label={I18n.t('proposals.role_edit.name')}
      rightButton={rightButton}
      target={id}
    >
      <div className={styles.roleAutocomplete}>
        <input
          className={legacyClasses}
          disabled
          id={id}
          value={value}
        />
      </div>
    </FormGroup>
  )
}

export default DisabledRoleName
